import React from "react";
import { Power } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { startCluster, stopCluster } from "../../store/cluster/actions";
import IconButton from "../../components/IconButton";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../components/ui/tooltip";


const ToggleSwitch = ({ showTooltip }) => {
    const dispatch = useDispatch();
    const { processing, clusterState } = useSelector((state) => state.Clusters); // -1: OFF, 0: Processing, 1: ON

    const handleClick = () => {
        if (clusterState === -1) {
            dispatch(startCluster());
        } else if(clusterState === 1) {
            dispatch(stopCluster());
        }
    };

    const isOn = clusterState === 1;
    const isOff = clusterState === -1;
    const isProcessing = processing === true && clusterState === 0;

    // Define colors and styles based on state
    const getButtonClasses = () => {
        let baseClasses = "relative transition-all duration-300 ease-in-out";
        
        if (isOn) {
            return `${baseClasses} border-green-500 text-green-500 bg-green-50 hover:bg-green-100 hover:text-green-500`;
        } else if (isOff) {
            return `${baseClasses} border-red-500 text-red-500 bg-red-50 hover:bg-red-100 hover:text-red-500`;
        } else if (isProcessing) {
            return `${baseClasses} border-yellow-500 text-yellow-500 bg-yellow-50`;
        } else {
            return `${baseClasses} border-yellow-500 text-yellow-500 bg-yellow-50`;
        }
    };

    const getVariant = () => {
        if (isOn) return "outline";
        if (isOff) return "outline";
        return "outline";
    };

    return (
        <div className="flex justify-center items-center">
            <div className="relative">
                {/* Spinning border for processing state */}
                {isProcessing && (
                    <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-yellow-500 animate-spin"></div>
                )}
                {isOff ? 
                    <TooltipProvider>
                        <Tooltip open={showTooltip}>
                            <TooltipTrigger asChild>
                                <div>
                                    <IconButton
                                        variant={getVariant()}
                                        size="icon"
                                        rounded="full"
                                        Icon={Power}
                                        onClick={handleClick}
                                        disabled={isProcessing}
                                        className={getButtonClasses()}
                                    />
                                </div>
                            </TooltipTrigger>
                            <TooltipContent side="right">

                                <div className="text-center">
                                Please enable the Service Hub before you
                                <br />
                                Start the Field Mapping or ETL Process
                                </div>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider> :
                    <IconButton
                        variant={getVariant()}
                        size="icon"
                        rounded="full"
                        Icon={Power}
                        onClick={handleClick}
                        disabled={isProcessing}
                        className={getButtonClasses()}
                    />
                }

            </div>
        </div>
    );
};

export default ToggleSwitch;